import styled from '@emotion/styled'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'

import { useWatch } from 'react-hook-form'

import { Icon } from 'design-system/components/Icon'
import colors from 'design-system/tokens/colors'
import fontSizes from 'design-system/tokens/fontSizes'
import fontWeights from 'design-system/tokens/fontWeights'
import spacing from 'design-system/tokens/spacing'
import formatPhoneNumber from 'web-client/utils/formatPhoneNumber'

const Text = styled.p`
  font-size: ${fontSizes.bodyLarge};
  color: ${colors.grays.l1};
  margin: 0;
  line-height: 1.4;
`

const PhoneNumber = styled(Text)`
  font-weight: ${fontWeights.semibold};
  margin-bottom: ${spacing.xs};
`
const MainSuccessContent = styled.div`
  flex: 1;
  padding: ${spacing.xl} ${spacing.s};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  gap: ${spacing.m1};
`

const Success = () => {
  const phoneNumber = useWatch({ name: 'phoneNumber' })
  return (
    <MainSuccessContent>
      <Icon color={colors.greens.l1} icon={faCircleCheck} iconSize="xxxlarge" role="img" />
      <Text>Your text message request has been sent to: </Text>
      <PhoneNumber>{formatPhoneNumber(phoneNumber as string)}</PhoneNumber>
      <Text>
        What’s next? <br />
        Tap the link in the text to request service
      </Text>
    </MainSuccessContent>
  )
}

export default Success
